import React from 'react';
import ContentContainer from '~/src/components/ContentContainer';
import { imgOteLogoWhiteSvg } from '~/src/images';
import { positions } from '~/src/lib';
import styles from '~/src/lib/styles.json';
import { OtePlayer } from '~/src/models/OtePlayer';
import { OteTeam } from '~/src/models/OteTeam';
import { colorFromInt } from '~/src/overtime-lib/src/www/lib';
import './Profile.scss';

const Profile = ({ player, team }: { player: OtePlayer; team: OteTeam }) => {
	const teamColor = { color: team?.is_current ? colorFromInt(team.secondary_foreground_color) : styles.COLOR.WHITE };
	return (
		<div
			className="PlayerProfile"
			style={{ backgroundColor: team?.is_current ? colorFromInt(team.secondary_color) : styles.COLOR.BRAND_PRIMARY }}
		>
			<ContentContainer>
				<a href={`/players/${player.id}`} className="ProfileContainer">
					<div
						style={{
							backgroundImage: `linear-gradient(180deg, ${colorFromInt(
								team?.primary_color ?? 0xaaaaaa,
							)} 0%, ${colorFromInt(team?.primary_color ?? 0xaaaaaa)} 20% , white)`,
						}}
						className={['ImageContainer', !player.image_path ? 'Placeholder' : null].filter(Boolean).join(' ')}
					>
						<img
							alt={player.full_name}
							src={player.image_path ? `https://images.overtime.tv/${player.image_path}` : imgOteLogoWhiteSvg}
						/>
					</div>
					<div>
						<h1 style={teamColor}>
							<div>{player.first_name}</div>
							<div>{player.family_name}</div>
						</h1>
						<div className="Position">{positions[player.position]}</div>
					</div>
				</a>
			</ContentContainer>
		</div>
	);
};

export default Profile;
